import {
    CalendarClock,
    CheckCircle2,
    Clock3,
    FileText,
    ShieldAlert,
    UserRoundCheck,
    XCircle,
} from 'lucide-react';

const STATUS_META = {
    draft: {
        label: 'Draft',
        Icon: FileText,
        classes:
            'bg-[hsl(var(--status-bg-neutral))] text-[hsl(var(--status-neutral))] border border-[hsl(var(--status-border-neutral))]',
    },
    scheduled: {
        label: 'Scheduled',
        Icon: CalendarClock,
        classes:
            'bg-[hsl(var(--status-bg-info))] text-[hsl(var(--info))] border border-[hsl(var(--status-border-info))]',
    },
    published: {
        label: 'Published',
        Icon: CheckCircle2,
        classes:
            'bg-[hsl(var(--status-bg-success))] text-[hsl(var(--success))] border border-[hsl(var(--status-border-success))]',
    },
    pending_external: {
        label: 'Pending',
        Icon: Clock3,
        classes:
            'bg-[hsl(var(--status-bg-warning))] text-[hsl(var(--warning))] border border-[hsl(var(--status-border-warning))]',
    },
    failed: {
        label: 'Failed',
        Icon: XCircle,
        classes:
            'bg-[hsl(var(--status-bg-danger))] text-[hsl(var(--danger))] border border-[hsl(var(--status-border-danger))]',
    },
    flagged: {
        label: 'Flagged',
        Icon: ShieldAlert,
        classes:
            'bg-[hsl(var(--status-bg-danger))] text-[hsl(var(--danger))] border border-[hsl(var(--status-border-danger))]',
    },
    awaiting_review: {
        label: 'Review',
        Icon: UserRoundCheck,
        classes:
            'bg-[hsl(var(--status-bg-warning))] text-[hsl(var(--warning))] border border-[hsl(var(--status-border-warning))]',
    },
    cancelled: {
        label: 'Cancelled',
        Icon: XCircle,
        classes:
            'bg-[hsl(var(--status-bg-neutral))] text-[hsl(var(--status-neutral))] border border-[hsl(var(--status-border-neutral))]',
    },
    open: {
        label: 'Open',
        Icon: FileText,
        classes:
            'bg-[hsl(var(--status-bg-info))] text-[hsl(var(--info))] border border-[hsl(var(--status-border-info))]',
    },
    replied: {
        label: 'Replied',
        Icon: CheckCircle2,
        classes:
            'bg-[hsl(var(--status-bg-success))] text-[hsl(var(--success))] border border-[hsl(var(--status-border-success))]',
    },
};

export function StatusBadge({ status, className = '' }) {
    const meta = STATUS_META[status] || STATUS_META.draft;
    const Icon = meta.Icon;
    return (
        <span
            className={`inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-[11px] font-medium ${meta.classes} ${className}`}
        >
            <Icon className="h-3 w-3" />
            <span>{meta.label}</span>
        </span>
    );
}

const CLASSIFICATION_META = {
    positive: {
        label: 'Positive',
        classes:
            'bg-[hsl(var(--success)/0.12)] text-[hsl(var(--success))] border border-[hsl(var(--success)/0.22)]',
    },
    question: {
        label: 'Question',
        classes:
            'bg-[hsl(var(--info)/0.12)] text-[hsl(var(--info))] border border-[hsl(var(--info)/0.22)]',
    },
    lead: {
        label: 'Lead',
        classes:
            'bg-[hsl(var(--warning)/0.12)] text-[hsl(var(--warning))] border border-[hsl(var(--warning)/0.22)]',
    },
    spam: {
        label: 'Spam',
        classes:
            'bg-[hsl(var(--status-bg-neutral))] text-[hsl(var(--status-neutral))] border border-[hsl(var(--status-border-neutral))]',
    },
    troll: {
        label: 'Troll',
        classes:
            'bg-[hsl(var(--danger)/0.12)] text-[hsl(var(--danger))] border border-[hsl(var(--danger)/0.22)]',
    },
    support: {
        label: 'Support',
        classes:
            'bg-[hsl(var(--brand-accent-2)/0.12)] text-[hsl(var(--brand-accent-2))] border border-[hsl(var(--brand-accent-2)/0.22)]',
    },
};

export function ClassificationBadge({ category, className = '' }) {
    const meta = CLASSIFICATION_META[category];
    if (!meta) {
        return (
            <span
                className={`inline-flex items-center gap-1 rounded-md border border-dashed border-border px-2 py-0.5 text-[11px] text-muted-foreground ${className}`}
            >
                Unclassified
            </span>
        );
    }
    return (
        <span
            className={`inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-[11px] font-medium ${meta.classes} ${className}`}
        >
            {meta.label}
        </span>
    );
}
